import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import rulePopout from 'components/triggers/RulePopout';
import CheckIcon from '@material-ui/icons/Check';
import KeywordTopicSelection from 'components/triggers/keyword-topic-selection/KeywordTopicSelection';
import FilterWordsStore from 'stores/triggers/FilterWordsStore';
import FilterWordsActions from 'actions/triggers/FilterWordsActions';
import FlatButton from 'components/pure/utils/FlatButton';
import {
  CallConditionType,
  KeywordTopicPhrase,
  MentionedAtLeastOnceCondition,
  SpeakerCondition,
} from 'records/CallTrigger';
import './KeywordTopicSelectionStyles.styl';

class KeywordTopicSelectionContainer extends React.Component {
  constructor(props) {
    super(props);

    this.conditionChange = this.conditionChange.bind(this);
    this.topicKeywordChange = this.topicKeywordChange.bind(this);
    this.locationTypeChange = this.locationTypeChange.bind(this);

    this.state = {
      condition: new MentionedAtLeastOnceCondition({
        speakerType: SpeakerCondition.EXTERNAL,
        negated: false,
        keywordTopicPhrase: new KeywordTopicPhrase(),
      }),
      topicKeywords: false,
    };
  }

  static getStores() {
    return [FilterWordsStore];
  }

  static getPropsFromStores() {
    return {
      filterWords: FilterWordsStore.getState().filterWords, // despite the name, these are all topics.
    };
  }

  conditionChange(condition) {
    this.setState({
      condition,
    });
    condition.ready() && this.props.updateSelection && this.props.updateSelection(condition);
  }

  locationTypeChange(locationType) {
    this.setState({locationType});
  }

  topicKeywordChange(topicKeywords) {
    this.setState({
      topicKeywords: topicKeywords,
      // switching between keyword and topic will wipe keywordTopicPhrase, forcing the user to choose again
      condition: this.state.condition.setIn(['keywordTopicPhrase', 'filterWordId'], null),
    });
  }

  componentDidMount() {
    FilterWordsActions.fetchAll();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.condition && nextProps.condition.type) {
      const selectedWord = nextProps.filterWords.find(
        w => w.id === nextProps.condition.keywordTopicPhrase.filterWordId
      );
      this.setState({
        condition: nextProps.condition,
        topicKeywords: !!selectedWord,
      });
    }
  }

  canSave() {
    const {condition} = this.state;
    return (
      condition.keywordTopicPhrase &&
      (condition.keywordTopicPhrase.filterWordId || condition.keywordTopicPhrase.keyword) &&
      (condition.type === CallConditionType.MENTIONED_AT_LEAST_ONCE ||
        (condition.type === CallConditionType.MENTIONED_AT && condition.range))
    );
  }

  render() {
    const canSave = this.canSave();
    return (
      <div className="rule-select-popup">
        <KeywordTopicSelection
          {...this.props}
          {...this.state}
          conditionChange={this.conditionChange}
          topicKeywordChange={this.topicKeywordChange}
          locationTypeChange={this.locationTypeChange}
        />
        <div className="selection-buttons">
          <button
            className={canSave ? 'save' : 'save disabled'}
            disabled={!canSave}
            onClick={() => this.props.saveSelection(this.state.condition)}>
            <CheckIcon htmlColor={canSave ? 'white' : 'gray'} />
          </button>
          <FlatButton onClick={() => this.props.closeRequest('cancel')}>Cancel</FlatButton>
        </div>
      </div>
    );
  }
}

export default rulePopout(connectToStores(KeywordTopicSelectionContainer));
